import { List, styled } from '@mui/material';

export const ListStyled = styled(List)(({ theme }) => ({
  '& .MuiListItem-root': {
    alignItems: 'flex-start',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    gap: '16px',

    '&:not(:last-child)': {
      paddingBottom: '12px',
    },
  },

  '& .MuiListItemIcon-root': {
    minWidth: 'auto',
    width: '32px',
    height: '32px',
    alignItems: 'center',
    justifyContent: 'center',

    '& svg': {
      height: '18px',
      color: theme.palette.colors.onPrimaryBackground,
    },
  },

  '& .MuiListItemText-root': {
    marginTop: 0,
    marginBottom: 0,

    '& .MuiTypography-root': {
      lineHeight: '24px',
      color: theme.palette.colors.onPrimaryBackground,
      whiteSpace: 'pre-line',

      '&.MuiListItemText-primary': {
        fontSize: '16px',
      },
      '&.MuiListItemText-secondary': {
        fontSize: '12px',
      },
    },
  },
}));
